/**
 * Created by xiajing on 2018/1/18.
 */
import * as lossAssTypes from '../constants/ActionTypes'
import * as types from '../../constants/ActionTypes'
import { handleActions } from 'redux-actions'
const reducers = {};
const initialState = {
    wxProgramPushUrl:'',
    getFetchLivePlayResult:'',
    getImLoginInfoResult:'',
    sendedTxfitUrlToBackgroud:false
}


reducers[lossAssTypes.FETCH_LIVE_PLAY_SUCCESS] = (state,action) =>{

    return Object.assign({}, state,{
        getFetchLivePlayResult:action.payload
    })
}


reducers[lossAssTypes.RECEIVE_TXFIT_URL] = (state,action)=>{

    return Object.assign({}, state,{
        wxProgramPushUrl: action.payload.sendurl,
        getFetchLivePlayResult: action.payload.playurl,
        sendedTxfitUrlToBackgroud: false
    })
}

reducers[lossAssTypes.SENDED_TXFIT_URL_TO_BACKGROUD] = (state,action)=>{

    return Object.assign({}, state,{
        sendedTxfitUrlToBackgroud: true,
    })
}

reducers[types.END_SESSION_LOSSASS] = (state,action)=>{

    return Object.assign({}, state,{
        wxProgramPushUrl: '',
        getFetchLivePlayResult: '',
        sendedTxfitUrlToBackgroud: false
    })
}
export default handleActions(reducers,initialState) 
